import { localizeProducer as localize } from "features/localization/localizeService";


export enum ProducerAccountPermission {
    PrimaryUser = 1,
    MakeViewSign = 2,
    ViewSign = 3,
    ViewOnly = 4
}


export const AllProducerAccountPermissions: ProducerAccountPermission[] = [
    ProducerAccountPermission.PrimaryUser,
    ProducerAccountPermission.MakeViewSign,
    ProducerAccountPermission.ViewSign,
    ProducerAccountPermission.ViewOnly
]

export function getProducerAccountPermissionText(permission: ProducerAccountPermission): string {
    switch (permission) {
        case ProducerAccountPermission.PrimaryUser:
            return localize("ProducerAccountPermission_Value_PrimaryUser");
        case ProducerAccountPermission.MakeViewSign:
            return localize("ProducerAccountPermission_Value_MakeViewSign");
        case ProducerAccountPermission.ViewSign:
            return localize("ProducerAccountPermission_Value_ViewSign");
        case ProducerAccountPermission.ViewOnly:
            return localize("ProducerAccountPermission_Value_View");
        default:
            return "";
    }
}